export const stringFrom = (s: string, from: string) =>
  s.substring(s.indexOf(from))

export const googleMapsSearch = (query: string) =>
  `https://maps.google.com/?${new URLSearchParams({ q: query })}`
